import { GetServerSideProps, InferGetServerSidePropsType } from 'next'
import { IGetServerSidePropsData } from './index.types'
import { client } from '@/libs/apollo'
import styled from 'styled-components'

import Head from '@/components/head/head.component'
import PostLayout from '@/layouts/post/post.layout'

import {
  CATEGORIES,
  ICategoriesQueryData,
} from '@/graphql/category/category.queries'
import {
  IPostsQuery,
  IPostsQueryVars,
  POSTS_QUERY,
} from '@/graphql/post/post.queries'

export const getServerSideProps: GetServerSideProps<IGetServerSidePropsData> =
  async (context) => {
    const categoriesData = await client.query<ICategoriesQueryData>({
      query: CATEGORIES,
    })

    const { data: postsData } = await client.query<
      IPostsQuery,
      IPostsQueryVars
    >({
      query: POSTS_QUERY,
      variables: {
        query: {
          limit: 5,
          offset: 0,
        },
      },
    })

    const { data: patreonPostsData } = await client.query<
      IPostsQuery,
      IPostsQueryVars
    >({
      query: POSTS_QUERY,
      variables: {
        query: {
          limit: 10,
          offset: 0,
          isPublic: false,
        },
      },
    })

    return {
      props: {
        categories: categoriesData.data.categories.items,
        patreonPosts: patreonPostsData.posts.items,
        latestPosts: postsData.posts.items,
      },
    }
  }

export default function AboutPage({
  categories,
  latestPosts,
  patreonPosts,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <PostLayout
      categories={categories ?? []}
      latestPosts={latestPosts ?? []}
      patreonPosts={patreonPosts ?? []}
    >
      <Head
        title="IVETARS | Články, s ktorými zaručene nestratíš čas"
        description="Vegánstvo, piercing, dredy, úvahy a šialenosti bežného života. O tom, ako tvoje rozhodnutia a pohľad na svet ovplyvňujú (nielen) tvoj život."
        image="https://res.cloudinary.com/coderkin/image/upload/v1680204771/ivetars-blog/meta-placeholder_zi2zjr.png"
      ></Head>
      <div className="container">
        <Title>O mne</Title>
        <Container>
          <p>Ahojte,</p>
          <p></p>
          <p>
            som Iveta, ktorá kľučkuje internetom, knihami, prednáškami,
            rozhovormi aj bakalárskymi prácami. Rada debatujem so zaujímavými
            ľuďmi rôznych názorov a pohľadov. Všímam si, aký obrovský vplv majú
            naše rozhodnutia na svet, na nás. Do hĺbky zisťujem, ako naša myseľ
            ovplyvňuje naše životy a ako z toho vieme vyťažiť vo svoj prospech.
          </p>
          <p>
            Píšem, pretože sa rada zamýšľam a rada o mojich myšlienkach
            rozprávam. Nie všetkých však baví počúvať ma a preto má na tomto
            mieste každý možnosť vybrať si, či si článok prečíta alebo nie.
            Vedeli ste, že čítanie rozvíja náš mozog? Tak už to viete :)
          </p>

          <p>Vítam všetkých a ĎAKUJEM za prejavenú podporu💚</p>
        </Container>
      </div>
    </PostLayout>
  )
}

const Title = styled.h1`
  font-size: 3rem;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 5rem;
  line-height: 1.25;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 6.2rem;
  }
`

const Container = styled.div`
  max-width: 62rem;
  margin: 0 auto;

  img {
    width: 100%;
    max-height: 30rem;
    margin-bottom: 2rem;
    object-fit: contain;
  }

  blockquote {
    font-size: 1.6rem;
    border-left: 0.5rem solid ${({ theme }) => theme.fonts.secondary};
    padding-left: 2rem;

    &:not(:last-child) {
      padding-bottom: 1rem;
    }

    &:last-child {
      margin-bottom: 4rem;
    }
  }

  p {
    font-size: 1.6rem;
    line-height: 1.5;
    margin-bottom: 2rem;
    font-weight: 300;
  }

  h1 {
    font-size: 3.2rem;
    line-height: 1.2;
    margin-bottom: 2rem;
  }

  h2 {
    font-size: 2.8rem;
    line-height: 1.2;

    margin-bottom: 2rem;
  }

  h3 {
    font-size: 2.4rem;
    line-height: 1.2;

    margin-bottom: 2rem;
  }

  h4 {
    font-size: 2rem;
    line-height: 1.2;

    margin-bottom: 2rem;
  }

  h5 {
    font-size: 1.6rem;
    line-height: 1.2;

    margin-bottom: 2rem;
  }

  h6 {
    font-size: 1.2rem;
    line-height: 1.2;

    margin-bottom: 2rem;
  }

  ul {
    font-size: 1.6rem;
    line-height: 1.5;
    margin-bottom: 2rem;
  }

  ol {
    font-size: 1.6rem;
    line-height: 1.5;
    margin-bottom: 2rem;
  }

  li {
    font-size: 1.6rem;
    line-height: 1.5;
    margin-bottom: 2rem;
  }

  a {
    font-size: 1.6rem;
    line-height: 1.5;
    margin-bottom: 2rem;
    color: ${({ theme }) => theme.fonts.secondary};

    &:hover {
      text-decoration: underline;
    }
  }
`
